import { createContext } from 'react';

import type { ActionBarAction } from './actionBarAction';

export interface RegisterActionsOptions {
	priority?: number;
	overflowLimit?: number;
}

export interface ActionBarContextValue {
	actions: ActionBarAction[];
	overflowLimit: number;
	registerActions: (
		sourceId: string,
		actions: ActionBarAction[],
		options?: RegisterActionsOptions
	) => void;
	unregisterActions: (sourceId: string) => void;
}

export const ActionBarContext = createContext<ActionBarContextValue | undefined>(undefined);
